import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { AuhMethods } from '../../../../services/auth';
import ContentLoader from '../../ContentLoader';
import { alpha, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { CurrentAuthMethod } from '../../../constants/AppConstants';
import AuthWrapper from './AuthWrapper';
import { NavLink } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { regexPhoneNumber } from 'helpers/regex';
import { Visibility, VisibilityOff } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    authThumb: {
        backgroundColor: alpha(theme.palette.primary.main, 0.12),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
        [theme.breakpoints.up('md')]: {
            width: '50%',
            order: 2,
        },
    },
    authContent: {
        padding: 30,
        [theme.breakpoints.up('md')]: {
            width: props => (props.variant === 'default' ? '50%' : '100%'),
            order: 1,
        },
        [theme.breakpoints.up('xl')]: {
            padding: 50,
        },
    },
    titleRoot: {
        marginBottom: 14,
        color: theme.palette.text.primary,
    },
    textFieldRoot: {
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: alpha(theme.palette.common.dark, 0.12),
        },
    },
    textCapital: {
        textTransform: 'capitalize',
    },
    textAcc: {
        textAlign: 'center',
        '& a': {
            marginLeft: 4,
        },
        fontSize: 14,
    },
    alrTextRoot: {
        textAlign: 'center',
        [theme.breakpoints.up('sm')]: {
            textAlign: 'right',
        },
    },
    passwordInput: {
        '& .MuiFormControl-root': {
            width: '100%',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: alpha(theme.palette.common.dark, 0.12),
      },
        paddingBottom: '10px',
    },
}));

//variant = 'default', 'standard', 'bgColor'
const SignUp = ({ method = CurrentAuthMethod, variant = 'default', wrapperVariant = 'default' }) => {
    const {
        register,
        handleSubmit,
        setError,
        formState: { errors },
    } = useForm({ mode: 'onChange' });
    const dispatch = useDispatch();
    const [passwordType, setPasswordType] = useState(true);
    const [passwordConfirmType, setPasswordConfirmType] = useState(true);
    const classes = useStyles({ variant });

    const handleSubmitForm = dataForm => {
        if (dataForm.password !== dataForm.passwordConfirm) {
            setError('passwordConfirm', {
                type: 'notMatch',
                message: 'Mật khẩu xác nhận không khớp. Hãy thử lại.',
            });
        } else {
            dispatch(
                AuhMethods[method].onRegister({
                    name: dataForm.name,
                    phone: dataForm.phone,
                    password: dataForm.password,
                }),
            );
        }
    };

    return (
        <AuthWrapper variant={wrapperVariant}>
            <Box className={classes.authContent}>
                <Typography component="div" variant="h1" className={classes.titleRoot}>
                    Đăng kí
                </Typography>
                <form onSubmit={handleSubmit(handleSubmitForm)}>
                    <Box mb={2}>
                        <TextField
                            {...register('name', {
                                required: true,
                            })}
                            label="Tên đăng nhập"
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            className={classes.textFieldRoot}
                        />
                        {errors.name?.type === 'required' && <span style={{ color: '#cc3300' }}>Tên bắt buộc nhập</span>}
                    </Box>
                    <Box mb={2}>
                        <TextField
                            {...register('phone', {
                                required: true,
                                pattern: regexPhoneNumber,
                            })}
                            label="Số điện thoại"
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            className={classes.textFieldRoot}
                        />
                        {errors.phone?.type === 'required' && (
                            <span style={{ color: '#cc3300' }}>Số điện thoại bắt buộc nhập</span>
                        )}
                        {errors.phone?.type === 'pattern' && (
                            <span style={{ color: '#cc3300' }}>Số điện thoại sai định dạng</span>
                        )}
                    </Box>
                    <Box mb={2} className={classes.passwordInput}>
                        <FormControl variant="outlined">
                            <InputLabel htmlFor="outlined-adornment-password">Mật khẩu</InputLabel>
                            <OutlinedInput
                                {...register('password', {
                                    required: true,
                                    minLength: 8,
                                })}
                                id="outlined-adornment-password"
                                type={!passwordType ? 'text' : 'password'}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setPasswordType(passwordType => !passwordType)}
                                            // onMouseDown={handleMouseDownPassword}
                                            edge="end">
                                            {!passwordType ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                label="Mật khẩu"
                            />
                            {errors.password?.type === 'required' && (
                                <span style={{ color: '#cc3300' }}>Mật khẩu bắt buộc nhập</span>
                            )}
                            {errors.password?.type === 'minLength' && (
                                <span style={{ color: '#cc3300' }}>Mật khẩu ít nhất 8 ký tư</span>
                            )}
                        </FormControl>
                    </Box>
                    <Box mb={2} className={classes.passwordInput}>
                        <FormControl variant="outlined">
                            <InputLabel htmlFor="outlined-adornment-password">Xác nhận mật khẩu</InputLabel>
                            <OutlinedInput
                                {...register('passwordConfirm', {
                                    required: true,
                                })}
                                id="outlined-adornment-password"
                                type={!passwordConfirmType ? 'text' : 'password'}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setPasswordConfirmType(passwordType => !passwordType)}
                                            edge="end">
                                            {!passwordConfirmType ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                label="Xác nhận mật khẩu"
                            />
                            {errors.passwordConfirm?.type === 'required' && (
                                <span style={{ color: '#cc3300' }}>Vui lòng xác nhận mật khẩu</span>
                            )}
                            {errors.passwordConfirm?.type === 'notMatch' && (
                                <span style={{ color: '#cc3300' }}>{errors.passwordConfirm.message}</span>
                            )}
                        </FormControl>
                    </Box>
                    <Box
                        display="flex"
                        flexDirection={{ xs: 'column', sm: 'row' }}
                        alignItems={{ sm: 'center' }}
                        justifyContent={{ sm: 'space-between' }}
                        mb={3}>
                        <Box mb={{ xs: 2, sm: 0 }}>
                            <Button type="submit" variant="contained" color="primary">
                                Đăng kí
                            </Button>
                        </Box>
                    </Box>
                </form>

                <Box mb={3}>{dispatch(AuhMethods[method].getSocialMediaIcons())}</Box>

                <Typography className={classes.textAcc}>
                    Bạn đã có tài khoản?
                    <NavLink to="/signin">Đăng nhập</NavLink>
                </Typography>
                <ContentLoader />
            </Box>
        </AuthWrapper>
    );
};

export default SignUp;
